import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

interface LinkIconProps extends Omit<SvgIconProps, "viewBox"> {
}

export const LinkIcon: FunctionComponent<LinkIconProps> = (props) => {
	return (
		<SvgIcon
			viewBox="0 0 16 16"
			{...props}
		>
			<path
				clipRule="evenodd"
				d="M13.8479 5.91785C14.7469 4.91707 14.6585 3.34425 13.6569 2.34265C12.6229 1.30874 10.9804 1.2479 9.98664 2.24163L6.48478 5.7435L6.3947 5.83852C5.49579 6.8393 5.58419 8.41211 6.58579 9.41372C6.79699 9.62491 7.03709 9.79902 7.29744 9.93137L7.90165 8.74279L7.80195 8.68699C7.70419 8.62705 7.61246 8.55477 7.5286 8.47091C7.00042 7.94273 6.9708 7.14309 7.42758 6.68631L10.9294 3.18444L10.997 3.1225C11.4618 2.73161 12.211 2.78243 12.714 3.28546C13.2422 3.81364 13.2718 4.61328 12.8151 5.07006L11.0641 6.82099L12.0069 7.7638L13.7579 6.01287L13.8479 5.91785ZM2.15206 10.0812C1.25315 11.0819 1.34155 12.6548 2.34315 13.6564C3.37706 14.6903 5.01964 14.7511 6.01337 13.7574L9.51523 10.2555L9.60531 10.1605C10.5042 9.15971 10.4158 7.58689 9.41422 6.58529C9.20302 6.37409 8.96291 6.19999 8.70257 6.06764L8.09836 7.25622L8.19806 7.31202C8.29582 7.37196 8.38755 7.44424 8.47141 7.5281C8.99959 8.05628 9.02921 8.85592 8.57242 9.3127L5.07056 12.8146L5.00304 12.8765C4.53824 13.2674 3.78899 13.2166 3.28596 12.7135C2.75778 12.1854 2.72816 11.3857 3.18494 10.9289L4.93588 9.17801L3.99307 8.23521L2.24214 9.98614L2.15206 10.0812Z"
				fill="#79818F"
				fillRule="evenodd"
			/>
		</SvgIcon>
	);
};

export default LinkIcon;